<template v-if="skin">
<tr>
    <td v-if="$isPhoneDevice">
        <!-- Part title, MFG, Part#, Years, availability cart controls -->
        <v-layout row align-center justify-space-between wrap grow-shrink-0 :class="part.info ? 'px-2 pt-4' : 'px-2 mt-3 mb-4'" >
            <v-flex align-center md6 grow-shrink-0 class="phone-info">
                <v-layout align-center row justify-space-between>
                    <!-- Title, MFG, Part#, Years, -->
                    <v-flex grow-shrink-0 md8>
                        <div style="display:inline-block; font-size:15px;word-wrap: break-word">
                            <v-tooltip color="orange" bottom dark>
                                <a slot="activator">
                                    <v-layout column wrap>
                                        <v-flex>
                                            <p class="base--text font-weight-medium mb-1">{{ this.grouped_by == "manufacturer" ? part.description : part.mfgName }}</p>
                                        </v-flex>
                                    </v-layout>
                                </a>
                            </v-tooltip>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </td>
</tr>
</template>
<script>
import { mapState, mapActions } from "vuex";
import {ReadMoreDirective} from "@/utils/directives";

export default {
  name: "PartRow",
  props: {
    part: {
      type: Object,
      required: true
    },
    grouped_by: {
      type: String,
      required: true
    }
  },
  directives: {
   ReadMore: ReadMoreDirective,
  },
  computed: {
    ...mapState({
      hasWarranties: state => state.settings.config.hasWarranties,
      skin: state => state.settings.skin,
      partList: state => state.parts.partListBasket,
      thumbnailURL: state => state.parts.partsResults
    }),
    defaultThumbnailURL() {
      return `url('/images/image-placeholder.png')`;
    },
    defaultThumbnail() {
      return {
        backgroundImage: this.defaultThumbnailURL,
        backgroundPosition: "center center",
        backgroundSize: "72px"
      };
    },
  },
  methods: {
    ...mapActions({
      TOGGLE_MODAL_STATE: "modals/TOGGLE_MODAL_STATE",
      GET_C2C: "parts/GET_C2C",
      TOGGLE_SELECTION_C2C: "parts/TOGGLE_SELECTION_C2C"
    }),
    activeClass(headerValue) {
      return [
        "column sortable",
        this.pagination.descending ? "desc" : "asc",
        headerValue === this.pagination.sortBy ? "active" : ""
      ];
    },
    renderIcon(item) {
      return this.inBasket(item)
        ? ('<i aria-hidden="true" class="v-icon material-icons">check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    toggleSelected(item) {
      this.$emit("Update", { model: this.model, item });
    },
    inBasket(item) {
        return (this.partList.findIndex(i => i === item)) !== -1
    },
    async showC2C(url) {
      await this.SET_C2C(url);
      this.TOGGLE_MODAL_STATE({
        name: "c2c",
        value: true
      });
    },
      async openGraphicsUrl(item) {
      await this.TOGGLE_SELECTION_C2C({model: "c2c", item});
      await this.GET_C2C();
    },
  }
};
</script>
<style lang="stylus" scoped>

    .specific-condition-comment {
        color: var(--v-warning-darken3)
        padding: 12px 12px 0;

        i {
            font-size 14px
        }
    }

    #bundlesButton
        text-transform none
        padding 0
        img
            width 2em

    .thumbnail
        margin-right 20px
    .extension-row
        .part-info,
        .specific-condition-comment
            padding 20px 20px 0 112px

        .part-info
            opacity .76

    .phone-info
        max-width 50%

    .part-details
        font-size 13px

    .pricing-title
        font-size 13px
        opacity .7
        font-weight 500
        display inline-block

    /* Phone styles */
    @media( max-width: 750px)
        #bundlesButton
            img
                width 1.5em

        .phone-info
            max-width 100%

        .extended-information
            display none

        .extension-row
            .part-info,
            .specific-condition-comment
                padding 10px 20px 0 12px

        :deep().controls-layout
            .add-control,
            .quantity-control
                max-width 130px

            .add-control
                button
                    width 100%

            .qty-controllers
                input
                    padding 5px !important

        :deep().bundle-layout
            height 30px
            .v-menu__activator
                position relative
                top 1.5em


</style>
